// Substring used to recognise a "Turnstile token missing/invalid" signup error from the
const TURNSTILE_ERROR_MESSAGE_MATCH = 'captcha token';

export const isTurnstileTokenError = (message?: string): boolean =>
  message?.toLowerCase().includes(TURNSTILE_ERROR_MESSAGE_MATCH) ?? false;
